import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import cloneDeep from 'lodash/cloneDeep';
import bindingHelpers from '../binding/helpers';
import visibilityHelpers from '../visibility/helpers';
import fieldsHelper from '../utils/fieldsHelper';
import formHelper from '../utils/formHelper';
/**
 * @param {import('./types').EcrionFormState} state
 * @param {import('./types').EcrionFormRepeatingField} field
 * @param {Array<number>} values
 */

var removeFields = function removeFields(state, field, values) {
  if (!values || !values.length) return;
  field.childrenMap.forEach(function (item) {
    if (!values.includes(item.value)) return;
    item.children.forEach(function (fieldId) {
      delete state.fields[fieldId];
      delete state.data[fieldId];
      delete state.meta[fieldId];
      bindingHelpers.removeFieldFromBinding(fieldId, state);
      visibilityHelpers.removeVisibility(state, fieldId);
    });
  }); // remove the fields from children map

  field.childrenMap = field.childrenMap.filter(function (item) {
    return !values.includes(item.value);
  });
};
/**
 * @param {import('./types').EcrionFormState} state
 * @param {import('./types').EcrionFormRepeatingField} repeating
 * @param {Array<number>} values
 */


var createFields = function createFields(state, repeating, values) {
  if (!values || !values.length) return;
  if (!repeating.children) return;
  generateRepeatingItems(state, repeating, values);
};
/**
 * @param {import('./types').EcrionFormState} state
 * @param {import('./types').EcrionFormField} field
 * @param {Array<number>} oldValues
 * @param {Array<number>} newValues
 */


var updateValues = function updateValues(state, field, oldValues, newValues) {
  oldValues = oldValues || [];
  var itemsToRemove = oldValues.filter(function (val) {
    return !newValues.includes(val);
  });
  var itemsToAdd = newValues.filter(function (val) {
    return !oldValues.includes(val);
  });
  removeFields(state, field, itemsToRemove);
  createFields(state, field, itemsToAdd);
};
/**
 * This will generate the initial repeating items based on min items
 * @param {import('./types').EcrionFormState} state
 */


var generateInitialRepeating = function generateInitialRepeating(state) {
  var fieldId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!fieldId) return generateInitialRepeating(state, state.formId);
  var field = state.fields[fieldId];
  if (!field) return; // if no children map, then generate repeating

  if (field.type === 'repeating' && !field.childrenMap) {
    return generateRepeatingItems(state, field);
  }

  if (field.children && field.children.length) field.children.forEach(function (childId) {
    return generateInitialRepeating(state, childId);
  });
};
/**
 * @param {import('./types').EcrionFormState} state
 * @param {import('./types').EcrionFormRepeatingField} repeating
 */


var readDefaultValuesForRepeating = function readDefaultValuesForRepeating(state, repeating) {
  var fieldMeta = state.meta[repeating.originalId || repeating.id];
  var minItems = repeating.showEmptyItems ? fieldMeta && fieldMeta['minItems'] || 1 : 0;
  return _toConsumableArray(Array(minItems).keys());
};
/**
 * Generate default repeating items for specified repeating
 * @param {import('./types').EcrionFormState} state
 * @param {import('./types').EcrionFormRepeatingField} repeating
 * @param {Array<number>} values
 */


var generateRepeatingItems = function generateRepeatingItems(state, repeating, values) {
  var saveData = !values;
  values = values || readDefaultValuesForRepeating(state, repeating);
  var contextSuffix = fieldsHelper.findContextSuffix(repeating);
  repeating.childrenMap = saveData ? [] : repeating.childrenMap || [];
  if (saveData) state.data[repeating.id] = values;
  values.forEach(function (value) {
    if (repeating.children != undefined && repeating.children.length > 0) {
      var newFields = repeating.children.map(function (childId) {
        var newField = cloneDeep(state.fields[childId]);
        newField.id = newField.id + "".concat(contextSuffix, "_").concat(value);
        newField.parentId = repeating.id;
        newField.originalId = childId; // add to the fields (now it is a field with all rights)

        state.fields[newField.id] = newField;

        if (newField.type === 'repeating' || newField.type === 'datagroup') {
          formHelper.setMetaProp(state, newField.id, 'collapsed', newField.showCollapsed);
        }

        return newField;
      });
      repeating.childrenMap.push({
        value: value,
        children: newFields.map(function (f) {
          return f.id;
        })
      }); // for each new added field, we read default value

      fieldsHelper.readDefaultValues(newFields, state); // generate repeating items recursive

      newFields.filter(function (f) {
        return f.type === 'repeating';
      }).forEach(function (field) {
        return generateRepeatingItems(state, field);
      });
    }
  });
};

export default {
  updateValues: updateValues,
  generateInitialRepeating: generateInitialRepeating
};